import type { SqlImport } from '@/services/db/sql-import/entity';
import { sqlImportToDraft } from '../new/draft';
import { useBaselinedDraft } from '../new/use-baselined-draft';

/** A saved import under edit on one of the detail's tabs, against the import as loaded, then as last saved. */
export function useDraftEdits(sqlImport: SqlImport) {
  const { draft, baseline, differsFromBaseline, setDraftFields, resetToBaseline, rebaseline } = useBaselinedDraft(
    sqlImportToDraft(sqlImport),
  );
  return {
    draft,
    baseline,
    isDirty: differsFromBaseline(),
    hasUnsavedChanges: differsFromBaseline,
    setDraftFields,
    reset: resetToBaseline,
    markSaved: rebaseline,
  };
}

export type DraftEdits = ReturnType<typeof useDraftEdits>;
